import React from 'react'
import { Spinner } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import { OnProceedWithEstimate } from '../../actions/proceedEstimateActions'
import { useHistory } from 'react-router-dom'
import { fireInteractionCustomEvent } from '../../helpers'
import { PrimaryButton } from '@mmsg/louie'

const ProceedWithEstimateButton = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  let isProceedEstimateAccepted = useSelector(
    (state) => state.opportunity && state.opportunity.hasIndicativeProposal
  )
  let isSubmissionInProgress = useSelector(
    (state) => state.proceedEstimate && state.proceedEstimate.isSubmitting
  )
  return (
    <>
      {isProceedEstimateAccepted && (
        <>
          <PrimaryButton extendInMob className={props.className} disabled>
            {props.launchText}
          </PrimaryButton>
        </>
      )}
      {!isProceedEstimateAccepted && (
        <>
        {isSubmissionInProgress ? (
          <PrimaryButton
            variant={props.variant}
            size={props.size}
            className={props.className}
            extendInMob
          >
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="mb-1"
                />
                Submitting...
              </>
          </PrimaryButton>
        ):(
          <PrimaryButton
            variant={props.variant}
            size={props.size}
            className={props.className}
            extendInMob
            onClick={() => {
              dispatch(
                OnProceedWithEstimate(
                  props.opportunityId,
                  props.estimateId,
                  history
                )
              )
              fireInteractionCustomEvent({
                detail: {
                  eventType: 'custom link click',
                  data: {
                    category: 'button',
                    section: 'mylease',
                    text: 'proceed estimate',
                    label: 'proceed estimate',
                  },
                },
              })
            }}
          >
            {props.launchText}
          </PrimaryButton>
        )
      }
      </>
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    proceedEstimate: state.proceedEstimate,
  }
}

export default connect(mapStateToProps)(ProceedWithEstimateButton)
